import { render, staticRenderFns } from "./organizations-by-economic-activity.vue?vue&type=template&id=5eadb5d7&scoped=true&"
import script from "./organizations-by-economic-activity.vue?vue&type=script&lang=js&"
export * from "./organizations-by-economic-activity.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-economic-activity.vue?vue&type=style&index=0&id=5eadb5d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eadb5d7",
  null
  
)

export default component.exports